const actions = [
  {
      title: 'Think carefully about the change you\'d like to make.',
      text: 'Take some time to think about the change you would like to make. Try to be as specific as you can. E.g., I would like to quit smoking.',
  },
  {
      title: 'Write a list of things you would have to change or \'give up\'.',
      text: 'Write down anything you feel like you would be \'losing\' by committing to your goal. E.g., If you\'re quitting smoking, you may feel like you\'re \'losing\' something you enjoy, or if you\'re trying to become more active, you may feel like you\'re \'losing\' time watching your favourite TV shows.',
  },
  {
      title: 'Write a list of all the things you would gain by achieving your goal.',
      text: 'Think about the reasons why you would like to make this behaviour change, and what you will gain from it. How would it positively affect your health? Will it make you feel good? Will it save you some money? Will it allow you to have more time for other things? Make a note of these positive outcomes.',
  },
  {
    title: 'Take some time to reflect.',
    text: 'The intention is to focus more on what you\'re gaining, rather than what you\'re giving up. Take some time to yourself to reflect on these two lists and think about which is the most important to you. Try to see your behaviour change in a new light, with emphasis on all of the great things that will come from it.',
},
{
    title: 'Find a fun way to remind yourself of these outcomes.',
    text: 'Find a fun way to remind yourself of all that you\'ll be gaining. You could write these positive outcomes on post-it notes and stick them in places you\'ll see them throughout the day. ',
},
];

const tip = 'Taking a new perspective can sometimes be tricky, particularly if you\'re feeling apprehensive about the challenge you\'ve set. Try to be patient with yourself and remember that shifting your perspective can take time. It might help to have a friend or family member nudge you when you\'re struggling.';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
